export function buildCombinedDocument(clinical, pricing, manifest) {
  if (!clinical?.summary || !Array.isArray(clinical.findings) ||
      !pricing?.pricingSupportNarrative?.sections?.length) {
    throw new Error("Both medical analysis and a pricing-support narrative are required. Rerun older analyses that do not include the narrative.");
  }
  const citation = (refs) => (refs || []).map((ref) => {
    const document = manifest.find((item) => item.id === ref.documentId && Number(item.version) === ref.documentVersion);
    if (!document || (ref.page !== null && (!Number.isInteger(ref.page) || ref.page < 1))) {
      throw new Error("An analysis citation does not match the current case sources.");
    }
    return `${document.name}, version ${ref.documentVersion}, ${ref.page === null ? "physical page unavailable" : `p. ${ref.page}`}`;
  }).join("; ");
  const evidence = clinical.findings.map((finding) =>
    `${finding.finding}\n${finding.relevance}\nEvidence: ${finding.evidenceType}\nSources: ${citation(finding.sourceRefs) || "No source cited; requires review."}`
  );
  const sections = pricing.pricingSupportNarrative.sections.map((section) =>
    `${section.heading}\n\n${section.text}${section.sourceRefs?.length ? `\nSources: ${citation(section.sourceRefs)}` : ""}`
  );
  const limitations = [
    ...(clinical.missingInformation || []), ...(clinical.riskFlags || []),
    ...(pricing.missingInformation || []),
    ...(pricing.serviceLineAssessments || []).flatMap((item) => item.missingEvidence || []),
  ];
  return [
    "Combined Medical Necessity and Pricing Support",
    "Medical Necessity Evidence Review",
    clinical.summary, ...evidence,
    pricing.pricingSupportNarrative.title, ...sections,
    ...(limitations.length ? ["Evidence Limitations and Human Review", ...limitations] : []),
    "Source Documents",
    ...manifest.map((item) => `${item.name} - version ${item.version}`),
    "Human verification is required. This document does not determine IDR eligibility and has not been filed or sent.",
  ].join("\n\n");
}
